<template>
  <div class="template-padding">
    <div class="row">
      <div class="col col-sm-10">
        <h4 class="font-weight-bolder">
          RANK TYPE LIST
        </h4>
      </div>

      <div class="col col-sm-2 text-right">
        <button
          type="button"
          data-toggle="modal"
          data-target="#createRankTypeModal"
          class="btn btn-sm btn-outline-primary font-weight-bolder mr-4"
        >
          <span><i class="fas fa-plus" /></span>
          ADD NEW
        </button>
      </div>
    </div>

    <table class="table table-hover table-bordered">
      <thead>
        <tr class="table-header">
          <th>#</th>
          <th>CODE</th>
          <th>NAME</th>
          <th>STATUS</th>
          <th class="col-actions">
            ACTION
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(rankType, index) in rankTypes"
          :key="rankType.id"
          :class="{'inactive': !rankType.status}"
        >
          <td>{{ index+1 }}</td>
          <td>{{ rankType.code }}</td>
          <td>{{ rankType.name }}</td>
          <td>{{ (rankType.status) | setStatus }}</td>
          <td>
            <button
              type="button"
              class="btn btn-sm btn-xs btn-outline-info mr-1 font-weight-bolder"
              data-toggle="modal"
              data-target="#viewRankTypeModal"
              @click="showRankType(rankType.id)"
            >
              <span class="i fas fa-eye" />
              View
            </button>
            <button
              type="button"
              class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder"
              @click="removeRankType(rankType.id)"
            >
              <span><i class="fas fa-trash" /></span>
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { formMixins } from "../../../mixins/formMixins";

  export default {
      mixins: [formMixins],
      name: 'IndexRankTypes',
      methods: {
          ...mapActions([
              'getRankTypes',
              'viewRankType',
              'deleteRankType'
          ]),
          showRankType(id) {
              this.viewRankType(id);
          },

        async removeRankType(id) {
              if(await this.deleteAlert('Are you sure you want to delete this record?')) {
                  if(this.deleteRankType(id)) {
                      this.successAlert('Rank Successfully Deleted!', 'DELETE')
                  } else {
                      this.errorAlert('Rank Type Failed to Delete', 'DELETE');
                  }

              }
          }
      },
      created() {
          this.getRankTypes();
      },
      computed: {
          ...mapGetters([
              'rankTypes'
          ])
      }
  };
</script>

<style scoped>

</style>
